var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-navigation"},[_c('ul',_vm._l((_vm.linksList),function(link,index){return _c('li',{key:`link-${index}`},[(link.visible)?_c('router-link',{attrs:{"to":link.link}},[_vm._v(" "+_vm._s(_vm.$t(link.name))+" ")]):_vm._e()],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }